<template>
  <div id="base-station">
    <vx-tooltip
      v-if="userRole == 'ROLE_SYSADMIN' || userRole == 'ROLE_ADMIN'"
      class="customizer-btn-vesselBaseStation"
      text="Base station"
      position="left"
    >
      <vs-button
        v-if="collapsed"
        color="warning"
        icon-pack="feather"
        icon="icon-chevrons-left"
        style="border-top-right-radius: 0; border-bottom-right-radius: 0"
        @click="setCollapsed(false)"
      ></vs-button>
      <vs-button
        v-else
        color="primary"
        style="border-top-right-radius: 0; border-bottom-right-radius: 0"
        icon-pack="feather"
        icon="icon-grid"
        @click.stop="active = !active"
      ></vs-button>
    </vx-tooltip>
    <vs-sidebar
      v-model="active"
      hidden-background
      click-not-close
      default-index="1"
      color="primary"
    >
      <div slot="header" class="header-sidebar">
        <div
          class="customizer-header mt-2 flex items-center justify-between px-2"
        >
          <div>
            <h4>Base stations</h4>
          </div>
          <div class="flex justify-between flex-end">
            <div class="flex items-center px-2">
              <chevrons-right-icon
                size="1.5x"
                class="custom-class cursor-pointer"
                @click="setCollapsed(true)"
              ></chevrons-right-icon>
            </div>
            <feather-icon
              icon="XIcon"
              class="cursor-pointer"
              @click.stop="close"
            ></feather-icon>
          </div>
        </div>
        <vs-input
          v-model="searchQueryBaseStation"
          placeholder="Search:MMSI,Name"
          class="w-full input-rounded-full no-icon-border no-shadow"
          icon="icon-search"
          icon-pack="feather"
        />
      </div>
      <VuePerfectScrollbar class="scroll-area--listExcise pt-4">
        <table style="font-size: 12px; width: 100%" class="table">
          <tr
            v-for="(item, index) in baseStation"
            :key="index"
            class="pb-5 pt-4"
          >
            <vs-divider />
            <td class="text-center px-2">
              <b>{{ index + 1 }}.</b>
            </td>
            <td class="px-2 text-center">
              <feather-icon
                icon="AnchorIcon"
                svgClasses="w-5 h-5"
                class="pr-2"
              ></feather-icon>
            </td>
            <td class="px-2">
              <b>{{ item.mmsi }}</b>
              <br />
              {{ item.name }}
            </td>
            <td class="pb-3 pt-3 px-2">
              <a v-if="item.status" href="#">
                <vs-chip color="danger" style="cursor: auto" disabled
                  >View</vs-chip
                >
              </a>
              <a v-else href="#" @click="selectedBaseStation(item)">
                <vs-chip color="primary">View</vs-chip>
              </a>
            </td>
          </tr>
        </table>
      </VuePerfectScrollbar>
    </vs-sidebar>
  </div>
</template>
<script>
import { ChevronsRightIcon } from "vue-feather-icons";
import { mapState } from "vuex";
import VuePerfectScrollbar from "vue-perfect-scrollbar";
import axios from "axios";
import _ from "lodash";
import { API_GET_BASE_STATIONS } from "../../../constants/api";

export default {
  name: "BaseStation",
  components: {
    ChevronsRightIcon,
    VuePerfectScrollbar,
  },
  props: {
    isActive: {
      type: Boolean,
      default: false,
    },
    onActive: {
      type: Function,
      default() {},
    },
    onClose: {
      type: Function,
      default() {},
    },
    handleSelectedBaseStation: {
      type: Function,
      default() {},
    },
  },
  data() {
    return {
      userRole: "",
      active: false,
      searchQueryBaseStation: "",
      collapsed: false,
      baseStation: [],
    };
  },
  computed: mapState({
    newDataBaseStation: (state) => state.realtimeMonitoring.baseStationData,
    filteredKBBase() {
      return this.newDataBaseStation.filter(
        (item) =>
          item.mmsi
            .toLowerCase()
            .includes(this.searchQueryBaseStation.toLowerCase()) ||
          item.name
            .toLowerCase()
            .includes(this.searchQueryBaseStation.toLowerCase())
      );
    },
  }),
  watch: {
    active(val) {
      if (val) {
        this.onActive();
        this.setCollapsed(!val);
      } else {
        this.close();
      }
    },
    isActive(val) {
      if (!val) {
        this.active = false;
        this.collapsed = false;
      }
    },
  },
  created() {
    let role = localStorage.getItem("userRole");

    if (role == "ROLE_SYSADMIN") {
      this.userRole = "ROLE_SYSADMIN";
    } else if (role == "ROLE_ADMIN") {
      this.userRole = "ROLE_ADMIN";
    } else if (role == "ROLE_EDITOR") {
      this.userRole == "ROLE_EDITOR";
    } else if (role == "ROLE_VIEWER") {
      this.userRole = "ROLE_VIEWER";
    }
  },
  mounted() {
    this.accessEmail = localStorage.getItem("accessEmail");
    this.accessToken = localStorage.getItem("accessToken");
    const url = API_GET_BASE_STATIONS();
    axios
      .get(url, {
        params: {
          "q[longitude_not_null]": 1,
          "q[latitude_not_null]": 1,
        },
        headers: {
          "X-User-Email": this.accessEmail,
          "X-User-Token": this.accessToken,
        },
      })
      .then((res) => {
        const data = _.get(res, "data", []);
        this.baseStation = data.filter((item) => item.name != "");
      });
  },
  methods: {
    close() {
      this.onClose();
      // reset data
      this.active = false;
    },
    selectedBaseStation(item) {
      this.handleSelectedBaseStation(item);
    },
    setCollapsed(flag) {
      const elem = document.querySelector("#base-station");
      const sidebar = elem.getElementsByClassName("vs-sidebar");
      if (flag) {
        sidebar[0].style.width = "0vw";
        sidebar[0].style.visibility = "hidden";
      } else {
        sidebar[0].style.width = "300px";
        sidebar[0].style.visibility = "visible";
      }
      this.collapsed = flag;
    },
  },
};
</script>
<style lang="scss" scoped>
#sidebase-base-station {
  .vs-sidebar {
    position: fixed;
    z-index: 52000;
    width: 300px;
    max-width: 90vw;
  }
  @media screen and (max-width: 420px) {
    .h4,
    h4 {
      font-size: calc(14px + 6 * ((100vw - 420px) / 680));
    }
    .b,
    b {
      font-size: calc(12px + 6 * ((100vw - 420px) / 680));
    }
  }
}
.customizer-btn-vesselBaseStation {
  position: fixed;
  top: 42%;
  right: 0;
  border-top-right-radius: 0;
  border-bottom-right-radius: 0;
  z-index: 50000;
}

.scroll-area--listExcise {
  height: 100%;
  margin-bottom: 0px;
  margin-top: 0px;
}
.flex-end {
  position: absolute;
  right: 0px;
  margin: 2px;
}
</style>